angular.module('impactx.invoice').controller('InvoiceViewCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdDialog',
    '$redirect',
    'ProductSelectionService',
    'ToastService',
    'BackService',
    '$securityManager',
    'ToolbarService',
    'InvoiceDialogService',
    '$route',
    'TranslationService',
    InvoiceViewCtrl
]);

function InvoiceViewCtrl($scope, dataGen, $routeParams, $mdDialog, $redirect, ProductSelectionService, ToastService,
                         BackService, $securityManager, ToolbarService, InvoiceDialogService, $route, TranslationService) {
    this.selectedItemIndex = undefined;
    this.selectedOrderIndex = undefined;
    var ctrl = this;
    $scope.maxItemIndex = undefined;
    $scope.showMust = true;
    $scope.canClose = {};
    $scope.canClose.value = false;
    $scope.showComplaints = true;

    $scope.errorList = [];
    this.updatePriceLabels = function (item) {
        dataGen.getData({}, {item: item}, "/invoice/itemprice").then(function (data) {
            item.price = data.data;
        });
    };

    this.updateViewData = function () {
        $scope.errorList.length = 0;
        var hasPositions = false;
        var hasNormalPositions = false;

        var invoicePosition = 1;
        $scope.canClose.value = false;
        for (var i = 0; i < $scope.data.orders.length; i++) {
            var xPosition = 0;
            if ($scope.data.orders[i].canClose) {
                $scope.canClose.value = true;
            }
            for (var j = 0; j < $scope.data.orders[i].items.length; j++) {
                var item = $scope.data.orders[i].items[j];
                if (item.deleted || !impactX.isDefined(item, 'amount.value')) { // items with amount 0 count as deleted
                    continue;
                }
                hasPositions = true;
                if (!item.isExtraItem && !item.isExtraItemPosition) {
                    hasNormalPositions = true;
                }
                if (!item.isExtraItemPosition) {
                    xPosition++;
                }
                if (xPosition == 0) {
                    //if it starts with an extra item.
                    xPosition++;
                }
                item.invoicePosition.value = invoicePosition;
                item.position.value = xPosition;
                invoicePosition++;
            }
        }
        if (!hasPositions) {
            $scope.errorList.push($scope.trns.noPositions);
        }
        else if (!hasNormalPositions) {
            $scope.errorList.push($scope.trns.onlyConditions);
        }
        $scope.data.templateItem.position.value = xPosition + 1;

        defineButtons();
    };

    $scope.itemSelection = [];
    $scope.isSingleItemSelection = function () {
        return $scope.itemSelection.length === 1;
    }
    $scope.hasItemSelection = function () {
        return $scope.itemSelection.length > 0;
    }

    this.init = function () {
        if (!$routeParams.creditNote) {
            dataGen.getData($scope,
                {
                    id: $routeParams.id,
                    lotSupplierId: $routeParams.lotSupplierId ? $routeParams.lotSupplierId : 0,
                    orderComId: $routeParams.orderComId ? $routeParams.orderComId : 0,
                    deliveryDateValue: $routeParams.deliveryDateValue != undefined ? $routeParams.deliveryDateValue : -1,
                    pohId: $routeParams.pohId ? $routeParams.pohId : 0,
                    creditNoteForInvoice: $routeParams.creditNoteForInvoice ? $routeParams.creditNoteForInvoice : false
                }, "/invoice/view").then(function () {
                    ctrl.updateViewData();
                },
                function () {
                    if ($securityManager.isAuthorized()) {
                        BackService.back();
                    }
                });
        }
        else {
            dataGen.getData($scope,
                {
                    id: $routeParams.id,
                    lotSupplierId: $routeParams.lotSupplierId ? $routeParams.lotSupplierId : 0,
                    orderComId: $routeParams.orderComId ? $routeParams.orderComId : 0,
                    deliveryDateValue: $routeParams.deliveryDateValue != undefined ? $routeParams.deliveryDateValue : -1
                }, "/invoice/creditnote/view").then(function () {
                    ctrl.updateViewData();
                },
                function () {
                    if ($securityManager.isAuthorized()) {
                        BackService.back();
                    }
                });
        }
    };
    ctrl.init();

    this.selectAdditionalProduct = function (orderIndex) {
        $scope.data.currentOrderIndex = orderIndex;
        var config = {
            title: $scope.trns.addProductItem,
            locals: {
                // needed to receive the new position with price.
                cscId: $scope.data.cscId
            }
        };
        ProductSelectionService.open(config).then(function (selectedProduct) {
            $scope.additionalProduct = selectedProduct;
            if ($scope.additionalProduct) {
                var tempItem = JSON.parse(JSON.stringify($scope.data.templateItem));
                tempItem.productName.value = $scope.additionalProduct.name;
                tempItem.supplierNo.value = $scope.additionalProduct.supplierNo;
                tempItem.proId = $scope.additionalProduct.id;
                tempItem.amount.value = 1;
                tempItem.unit.selected = $scope.additionalProduct.unit;
                if ($scope.additionalProduct.priceInContract) {
                    tempItem.price.totalNetValue = $scope.additionalProduct.priceInContract.netValue.value;
                    tempItem.price.netValue.value = $scope.additionalProduct.priceInContract.netValue.value;
                    tempItem.price.taxRate.selected = $scope.additionalProduct.priceInContract.taxRate.selected;
                }
                ctrl.updatePriceLabels(tempItem);
                $scope.data.orders[$scope.data.currentOrderIndex].items.push(tempItem);
                $scope.data.currentOrderIndex = undefined;
                ctrl.updateViewData();
                ctrl.updateSummary();
            }
            else {
                $scope.data.currentOrderIndex = undefined;
            }
        });
    };

    this.updateSummary = function() {
        dataGen.postAsForm({}, {header: $scope.data}, "/invoice/getsummary").then(function (data) {
            $scope.data.summary = data.data;
        });
    }

    this.saveAndClose = function (event) {
        return ctrl.saveWithPreparation(event, "/invoice/saveandclose");
    };

    this.saveCreditNote = function () {
        return dataGen.postAsForm({}, {header: $scope.data}, "/invoice/creditnoteforinvoice").then(function (data) {
            $redirect.redirectTo(null, "invoicelistsupplier");
            ToastService.openStandardToast(data.trns.creditNoteCreationOk);
        });
    };

    this.saveWithPreparation = function (event, finalEntryPoint) {
        return dataGen.postAsForm({}, {header: $scope.data}, "/invoice/warnings").then(function (data) {
            $mdDialog.show({
                controller: "ConfirmSingleWarningsCtrl",
                controllerAs: "warningsCtrl",
                templateUrl: "shared/warnings/templates/confirm-single-warnings.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    warningList: data.data.warnings,
                    proceedLabel: $scope.trns.proceed,
                    abortLabel: $scope.trns.abort,
                    warningLabel: $scope.trns.warning
                }
            })
                .then(function () {
                    dataGen.postAsForm({}, {header: $scope.data}, finalEntryPoint).then(function () {
                        $redirect.redirectTo(null, "invoicelistsupplier");
                        ToastService.openStandardToast($scope.trns.saveSuccess);
                    });
                }, function () {
                });
        });
    };
    this.save = function (event) {
        return ctrl.saveWithPreparation(event, "/invoice/save");
    };

    this.abort = function () {
        if ($routeParams.id != undefined) {
            //we were NOT in the product selection dialog, so we can just call back().
            BackService.back();
        }
        else {
            //we were in the product selection dialog. This can only be done by supplier and invoice creation.
            //so we can redirect to invoice supplier list
            $redirect.redirectTo(null, "invoicelistsupplier")
        }
    };

    this.selectItem = function (orderIndex, posIndex) {
        var item = $scope.data.orders[orderIndex].items[posIndex];
        item.selected = !item.selected;
        if (item.selected) {
            $scope.itemSelection.push({
                id: item.id,
                item: item,
                posIndex: posIndex,
                orderIndex: orderIndex
            });
            ctrl.selectedItemIndex = posIndex;
            ctrl.selectedOrderIndex = orderIndex;
            $scope.maxItemIndex = $scope.data.orders[orderIndex].items.length;
        }
        else {
            const index = $scope.itemSelection.findIndex((val) => (val.posIndex === posIndex && val.orderIndex === orderIndex));
            if(index >= 0) {
                $scope.itemSelection.splice(index, 1);
            }
            if($scope.isSingleItemSelection())
            {
                ctrl.selectedItemIndex = $scope.itemSelection[0].posIndex;
                ctrl.selectedOrderIndex = $scope.itemSelection[0].orderIndex;
                $scope.maxItemIndex = $scope.data.orders[$scope.itemSelection[0].orderIndex].items.length;
            }
            else {
                ctrl.selectedItemIndex = undefined;
                ctrl.selectedOrderIndex = undefined;
                $scope.maxItemIndex = undefined;
            }
        }
    };

    this.removeItem = function (item, orderIndex, posIndex) {
        const index = $scope.itemSelection.findIndex((val) => (val.posIndex === posIndex && val.orderIndex === orderIndex));
        if(index >= 0) {
            $scope.itemSelection.splice(index, 1);
        }
        item.deleted = true;
        ctrl.updateViewData();
        ctrl.updateSummary();
    };

    this.itemAmountChanged = function (item) {
        ctrl.updatePriceLabels(item);
        ctrl.updateViewData();
        ctrl.updateSummary();
    }

    this.decreasePosition = function () {
        var toSwap = $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex - 1];
        $scope.itemSelection[0].item.invoicePosition.value--;
        toSwap.invoicePosition.value++;
        $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex - 1] = $scope.itemSelection[0].item;
        $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex] = toSwap;
        ctrl.selectedItemIndex--;
        $scope.itemSelection[0].posIndex = ctrl.selectedItemIndex;
    };

    this.increasePosition = function () {
        var toSwap = $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex + 1];
        $scope.itemSelection[0].item.invoicePosition.value++;
        toSwap.invoicePosition.value--;
        $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex + 1] = $scope.itemSelection[0].item;
        $scope.data.orders[ctrl.selectedOrderIndex].items[ctrl.selectedItemIndex] = toSwap;
        ctrl.selectedItemIndex++;
        $scope.itemSelection[0].posIndex = ctrl.selectedItemIndex;
    };

    this.editItem = function (event) {
        var item = $scope.itemSelection[0].item;
        $mdDialog.show({
            controller: "InvoiceItemEditCtrl",
            controllerAs: "invoiceItemEditCtrl",
            templateUrl: "modules/invoice/templates/invoiceitemedit.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                invoiceItem: item,
                currency: $scope.data.currency,
                taxRate: item.price.taxRate,
                unit: $scope.data.unit,
                orderComId: impactX.isDefined($scope, 'data.invoiceReceiver.id'),
                cscId: $scope.data.cscId,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                headerLabel: $scope.trns.itemEdit,
                noPriceMatchError: $scope.trns.noPriceMatchError,
                missingPriceAmountError: $scope.trns.missingPriceAmountError,
                missingUnitPriceError: $scope.trns.missingUnitPriceError,
                trns: $scope.trns
            }
        })
            .then(function (answer) {
                ctrl.updatePriceLabels(item);
                ctrl.updateSummary();
            }, function () {
            });
    };

    this.addFreeFormItem = function (event, orderIndex) {
        var tempItem = JSON.parse(JSON.stringify($scope.data.templateItem));
        $mdDialog.show({
            controller: "InvoiceItemEditCtrl",
            controllerAs: "invoiceItemEditCtrl",
            templateUrl: "modules/invoice/templates/invoiceitemedit.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                invoiceItem: tempItem,
                currency: $scope.data.currency,
                taxRate: $scope.data.taxRate,
                unit: $scope.data.unit,
                orderComId: impactX.isDefined($scope, 'data.invoiceReceiver.id'),
                cscId: $scope.data.cscId,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                headerLabel: $scope.trns.itemEdit,
                noPriceMatchError: $scope.trns.noPriceMatchError,
                missingPriceAmountError: $scope.trns.missingPriceAmountError,
                missingUnitPriceError: $scope.trns.missingUnitPriceError,
                trns: $scope.trns
            }
        })
            .then(function (answer) {
                ctrl.updatePriceLabels(tempItem);
                $scope.data.orders[orderIndex].items.push(tempItem);
                ctrl.updateViewData();
                ctrl.updateSummary();
            }, function () {
            });
    };

    this.addExtraItem = function (event, orderIndex) {
        var tempItem = JSON.parse(JSON.stringify($scope.data.templateItem));
        tempItem.isExtraItem = true;
        tempItem.amount.value = 1;
        $mdDialog.show({
            controller: "InvoiceItemEditCtrl",
            controllerAs: "invoiceItemEditCtrl",
            templateUrl: "modules/invoice/templates/invoiceitemedit.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                invoiceItem: tempItem,
                currency: $scope.data.currency,
                taxRate: $scope.data.taxRate,
                unit: $scope.data.unit,
                orderComId: impactX.isDefined($scope, 'data.invoiceReceiver.id'),
                cscId: $scope.data.cscId,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                headerLabel: $scope.trns.itemEdit,
                noPriceMatchError: $scope.trns.noPriceMatchError,
                missingPriceAmountError: $scope.trns.missingPriceAmountError,
                missingUnitPriceError: $scope.trns.missingUnitPriceError,
                trns: $scope.trns
            }
        })
            .then(function (answer) {
                ctrl.updatePriceLabels(tempItem);
                $scope.data.orders[orderIndex].items.push(tempItem);
                ctrl.updateViewData();
                ctrl.updateSummary();
            }, function () {
            });
    };

    this.selectedItemsLabel = function () {
        return $scope.itemSelection.length + ' ' + $scope.selectedTrns;
    }

    this.unselectAll = function () {
        $scope.itemSelection.forEach((selection)=> {
            selection.item.selected = false;
        });
        $scope.itemSelection = [];
        ctrl.selectedItemIndex = undefined;
        ctrl.selectedOrderIndex = undefined;
        $scope.maxItemIndex = undefined;
    };

    this.deleteItem = function () {
        $scope.itemSelection.forEach((selection)=> {
            selection.item.deleted = true;
            selection.item.selected = false;
        });
        $scope.itemSelection = [];
        ctrl.selectedItemIndex = undefined;
        ctrl.selectedOrderIndex = undefined;
        $scope.maxItemIndex = undefined;
        ctrl.updateViewData();
        ctrl.updateSummary();
    };

    this.deactivate = function (event) {
        InvoiceDialogService.deactivate(event, $scope.data.id, $scope.trns.deactivateMessage, $scope.trns.saveSuccess);
    };

    this.reactivate = function (event) {
        InvoiceDialogService.reactivate(event, $scope.data.id, $scope.trns.reactivateMessage, $scope.trns.saveSuccess);
    };

    this.getSetPohIds = function () {
        var setPohIds = [];
        for (var i = 0; i < $scope.data.orders.length; i++) {
            if ($scope.data.orders[i].pohId && $scope.data.orders[i].pohId > 0) {
                setPohIds.push($scope.data.orders[i].pohId);
            }
        }
        return setPohIds;
    };

    this.addOrder = function (event) {
        if (!$scope.data.isNewCreditNote) {
            $mdDialog.show({
                controller: "InvoiceAddOrderCtrl",
                controllerAs: "invoiceAddOrderCtrl",
                templateUrl: "modules/invoice/templates/invoiceaddorder.template.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    actionLabel: $scope.trns.addOrder,
                    withOrderRefLabel: $scope.trns.withOrderRef,
                    noOrderRefLabel: $scope.trns.noOrderRef,
                    orderLabel: $scope.trns.eOrder,
                    forwardLabel: $scope.trns.forward,
                    abortLabel: $scope.trns.abort,
                    confirmLabel: $scope.trns.confirm,
                    requiredLabel: $scope.trns.required,
                    noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                    lotSupplierId: $scope.data.lotSupplier.id,
                    cscId: $scope.data.cscId,
                    excludePOHIds: ctrl.getSetPohIds()
                }
            })
                .then(function (answer) {
                    dataGen.getData({}, {
                        pohId: answer.pohId,
                        deliveryDateValue: $scope.data.fixedDateValue
                    }, "/invoice/newinvoiceorder").then(function (data) {
                        $scope.data.orders.push(data.data);

                        ctrl.updateViewData();
                        ctrl.updateSummary();
                    });
                }, function () {
                });

        }
        else {
            dataGen.getData({}, {
                pohId: 0,
                deliveryDateValue: $scope.data.fixedDateValue
            }, "/invoice/newinvoiceorder").then(function (data) {
                $scope.data.orders.push(data.data);
                ctrl.updateViewData();
            });
        }
    };

    this.downloadMedia = function (mediaId) {
        DownloadService.openDownload('/invoice/download/media', mediaId);
    };

    this.removeOrder = function (index) {
        if ($scope.data.orders.length > 1) {
            $scope.data.orders.splice(index, 1);
        }
    };

    this.saveTemplate = function (event) {
        $mdDialog.show({
            controller: "InvoiceSaveTemplateCtrl",
            controllerAs: "invoiceSaveTemplateCtrl",
            templateUrl: "modules/invoice/templates/invoicesavetemplate.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: $scope.trns.saveTemplate,
                templateNameInput: $scope.data.templateNameInput,
                confirmLabel: $scope.trns.save,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                existingEntryWarning: $scope.trns.existingEntryWarning,
                receiverCompanyId: $scope.data.invoiceReceiver.id
            }
        })
            .then(function (answer) {
                dataGen.postAsForm({}, {
                    header: $scope.data,
                    templateName: answer.templateName
                }, "/invoice/savetemplate").then(function () {
                    ToastService.openStandardToast($scope.trns.saveSuccess);
                });
            }, function () {
            });
    };
    this.loadTemplate = function (event) {
        $mdDialog.show({
            controller: "InvoiceLoadTemplateCtrl",
            controllerAs: "invoiceLoadTemplateCtrl",
            templateUrl: "modules/invoice/templates/invoiceloadtemplate.tmp.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: $scope.trns.loadTemplate,
                confirmLabel: $scope.trns.confirm,
                abortLabel: $scope.trns.abort,
                requiredLabel: $scope.trns.required,
                noSelectedItemMessage: $scope.trns.noSelectedItemMessage,
                deleteLabel: $scope.trns.delete,
                receiverCompanyId: $scope.data.invoiceReceiver.id
            }
        })
            .then(function (answer) {
                dataGen.getData({}, {
                    templateId: answer.templateId,
                    deliveryDateValue: $scope.data.fixedDateValue
                }, "/invoice/loadtemplate").then(function (data) {
                    $scope.data.invoiceCreatorAddress = data.data.invoiceCreatorAddress;
                    $scope.data.invoiceReceiverAddress = data.data.invoiceReceiverAddress;
                    $scope.data.goodsReceiverAddress = data.data.goodsReceiverAddress;
                    $scope.data.attachments = data.data.attachments;
                    $scope.data.orders = data.data.orders;
                    $scope.data.payment = data.data.payment;
                    $scope.data.summary = data.data.summary;
                    data.data.invoiceCreator.selected.setFromBackend = true;
                    $scope.data.invoiceCreator.selected = data.data.invoiceCreator.selected;
                    ctrl.updateViewData();
                });

            }, function () {
            });
    };

    function defineButtons() {
        $scope.selectedTrns = TranslationService.get('selected');
        var buttonDefinition = [
            {
                icon: 'mdi-close',
                labelFunction: ctrl.selectedItemsLabel,
                action: ctrl.unselectAll,
                condition: $scope.hasItemSelection
            },
            {
                labelFunction: getAbortLabel,
                action: ctrl.abort,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.saveCreditNote,
                action: ctrl.saveCreditNote,
                type: 'validation',
                condition: canSaveCreditNote,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.saveAndClose,
                action: ctrl.saveAndClose,
                type: 'validation',
                condition: canSaveAndClose,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.addOrder,
                action: ctrl.addOrder,
                type: 'dialogaction',
                condition: canAddOrder
            },
            {
                label: $scope.trns.edit,
                action: ctrl.editItem,
                type: 'dialogaction',
                condition: canEditItem
            },
            {
                label: $scope.trns.increasePosition,
                action: ctrl.decreasePosition,
                type: 'dialogaction',
                condition: canDecreasePosition
            },
            {
                label: $scope.trns.decreasePosition,
                action: ctrl.increasePosition,
                type: 'dialogaction',
                condition: canIncreasePosition
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteItem,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.deactivate,
                action: ctrl.deactivate,
                type: 'dialogaction',
                condition: canDeactivate
            },
            {
                label: $scope.trns.reactivate,
                action: ctrl.reactivate,
                type: 'dialogaction',
                condition: canReactivate
            },
            {
                label: $scope.trns.completeComplaints,
                action: ctrl.completeComplaint,
                type: 'dialogaction',
                condition: canCompleteComplaint
            },
            {
                label: $scope.trns.headerComplaints,
                action: ctrl.headerComplaint,
                type: 'dialogaction',
                condition: canHeaderComplaint
            },
            {
                label: $scope.trns.deleteComplaints,
                action: ctrl.deleteComplaints,
                type: 'dialogaction',
                condition: canDeleteComplaints
            },
            {
                label: $scope.trns.saveTemplate,
                action: ctrl.saveTemplate,
                type: 'dialogaction',
                condition: canAccessTemplate
            },
            {
                label: $scope.trns.loadTemplate,
                action: ctrl.loadTemplate,
                type: 'dialogaction',
                condition: canAccessTemplate
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function getAbortLabel() {
        return ($scope.dialogData && $scope.dialogData.$dirty) ? $scope.trns.abort : $scope.trns.back;
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canSaveCreditNote() {
        return $scope.data.isCreditNoteForInvoice;
    }

    function canSaveAndClose() {
        return $scope.canClose.value && !$scope.data.isCreditNoteForInvoice && !$scope.data.isNewCreditNote;
    }

    function canAddOrder() {
        return $scope.data.multiOrdersAllowed && !$scope.hasItemSelection() && !$scope.data.readOnly;
    }

    function hasErrors() {
        return $scope.errorList.length;
    }

    function getErrors() {
        return $scope.errorList;
    }

    function canEditItem() {
        return $scope.isSingleItemSelection() && isEditable();
    }

    function canDecreasePosition() {
        return $scope.isSingleItemSelection() && $scope.itemSelection[0].item.invoicePosition.value > 1 && isEditable();
    }

    function canIncreasePosition() {
        return $scope.isSingleItemSelection() && $scope.itemSelection[0].item.invoicePosition.value < $scope.maxItemIndex && isEditable();
    }

    function canDelete() {
        return $scope.hasItemSelection() && (isEditable() || canEditItem());
    }

    function canDeactivate() {
        return $scope.data.canDeactivate;
    }

    function canReactivate() {
        return $scope.data.canReactivate;
    }

    function canAccessTemplate() {
        return !$scope.hasItemSelection() && isEditable();
    }

    ctrl.toggleComplaints = function () {
        $scope.showComplaints = !$scope.showComplaints;
    }

    this.completeComplaint = function (event) {
        InvoiceDialogService.showCompleteComplaintDialog(event, $scope.data.id);
    }

    this.headerComplaint = function (event) {
        InvoiceDialogService.showHeaderComplaintDialog(event, $scope.data.id);
    }

    this.deleteComplaints = function (event) {
        InvoiceDialogService.showComplaintDelete(event, $scope.data.id, $scope.trns.deleteComplaintsMessage).then(function() {
            BackService.back();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    ctrl.deleteComplaintItem = function (event, iciId) {
        InvoiceDialogService.showComplaintItemDelete(event, iciId, $scope.trns.deleteComplaintItemMessage).then(function () {
            $route.reload();
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    }

    function canCompleteComplaint() {
        return $scope.data.canCompleteComplaint;
    }

    function canHeaderComplaint() {
        return $scope.data.canHeaderComplaint;
    }

    ctrl.canDeleteHeaderComplaint = function (){
        return $scope.data.canDeleteHeaderComplaint;
    }

    function canDeleteComplaints() {
        return $scope.data.canDeleteCompleteComplaint;
    }

}